import { RouteConfig } from "vue-router";
import { LinksConstrains } from "@/enums/links.enum";
import { AppsConstraints } from "@/enums/apps.enum";

const OOCRoutes: Array<RouteConfig> = [
  {
    path: LinksConstrains.OOC,
    name: "menu.ooc",
    component: () => import("./index.vue"),
    meta: { isAuth: true, title: "POSRocket | OOC App", app: AppsConstraints.OOC },
  },
  {
    path: LinksConstrains.OOC_LOGIN,
    name: "menu.ooc_login",
    component: () => import("./login/index.vue"),
    meta: { isAuth: false, title: "POSRocket | OOC Login", app: AppsConstraints.OOC },
  },

  {
    path: LinksConstrains.OOC_DASHBOARD,
    name: "menu.ooc_dashboard",
    component: () => import("./dashboard/index.vue"),
    meta: { isAuth: true, title: "POSRocket | OOC Dashboard", app: AppsConstraints.OOC },
  },

  {
    path: LinksConstrains.OOC_MERCHANTS,
    name: "menu.ooc_merchants",
    component: () => import("./merchants/index.vue"),
    meta: { isAuth: true, title: "POSRocket | OOC MERCHANTS", app: AppsConstraints.OOC },
  },

  {
    path: LinksConstrains.OOC_INTEGRATION,
    name: "menu.ooc_integration",
    component: () => import("./integration/index.vue"),
    meta: { isAuth: true, title: "POSRocket | OOC Integration", app: AppsConstraints.OOC },
  },
  {
    path: LinksConstrains.OOC_MENUS,
    name: "menus",
    component: () => import("./menus/index.vue"),
    meta: { isAuth: true, title: "POSRocket | OOC Menus", app: AppsConstraints.OOC },
  },
  {
    path: LinksConstrains.OOC_MENU_INTEGRATION,
    name: "menus_integration",
    component: () => import("./menus/index.vue"),
    meta: { isAuth: true, title: "POSRocket | OOC Menus integration", app: AppsConstraints.OOC },
  },
  {
    path: LinksConstrains.OOC_ORDERS,
    name: "menu.ooc_orders",
    component: () => import("./orders/index.vue"),
    meta: { isAuth: true, title: "POSRocket | OOC Menus orders", app: AppsConstraints.OOC },
  },
];

export default OOCRoutes;
